(function () {
  'use strict';

  var HASH_TO_TAB = {
    '#product-specifications': 'specifications',
    '#specifications': 'specifications',
    '#product-connectivity': 'connectivity',
    '#product-features': 'features',
    '#product-qa': 'qa',
    '#product-questions': 'qa',
    '#shopify-product-reviews': 'reviews',
    '#product-tab-reviews': 'reviews',
    '#product-resources': 'resources',
  };

  function getRoot() {
    return document.querySelector('[data-pdp-tabs]');
  }

  function getPanels() {
    return document.querySelectorAll('[data-tab-panel]');
  }

  function getTabs(root) {
    return root ? root.querySelectorAll('[role="tab"][data-tab]') : [];
  }

  /** Mobil yatay sekme şeridinde seçili sekmeyi görünür alana taşır (scrollIntoView güvenilir değil). */
  function scrollActiveTabIntoBar(root, tab) {
    if (!root || !tab) return;
    if (!window.matchMedia || !window.matchMedia('(max-width: 719px)').matches) return;

    var bar = root.querySelector('.product-tab-bar');
    if (!bar || typeof bar.scrollTo !== 'function') return;

    var max = Math.max(0, bar.scrollWidth - bar.clientWidth);
    if (max <= 0) return;

    var barRect = bar.getBoundingClientRect();
    var tabRect = tab.getBoundingClientRect();

    var tabCenterInViewport = tabRect.left + tabRect.width / 2;
    var barCenterInViewport = barRect.left + barRect.width / 2;
    var targetScroll = bar.scrollLeft + (tabCenterInViewport - barCenterInViewport);

    targetScroll = Math.max(0, Math.min(targetScroll, max));
    bar.scrollTo({ left: targetScroll, behavior: 'smooth' });
  }

  function activate(tabKey) {
    var root = getRoot();
    var panels = getPanels();
    if (!root || !panels.length) return;

    var tabs = getTabs(root);
    tabs.forEach(function (tab) {
      var isMatch = tab.getAttribute('data-tab') === tabKey;
      tab.setAttribute('aria-selected', isMatch ? 'true' : 'false');
      tab.classList.toggle('product-tab-bar__item--active', isMatch);
      tab.tabIndex = isMatch ? 0 : -1;
      if (isMatch) {
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(function () {
            scrollActiveTabIntoBar(root, tab);
          });
        } else {
          scrollActiveTabIntoBar(root, tab);
        }
      }
    });

    panels.forEach(function (panel) {
      var key = panel.getAttribute('data-tab-panel');
      panel.hidden = key !== tabKey;
    });

    refreshAppFallbacks();
    refreshReviewsFallback();
    refreshAcqaPricingQuestionsCount();
  }

  function tabFromHash() {
    var h = (window.location.hash || '').toLowerCase();
    return HASH_TO_TAB[h] || null;
  }

  function refreshAppFallbacks() {
    document.querySelectorAll('[data-pdp-app-target]').forEach(function (host) {
      var panel = host.closest('.product-tab-panel');
      if (!panel) return;
      var fb = panel.querySelector('[data-pdp-app-fallback]');
      if (!fb) return;
      var hasApp = host.children.length > 0;
      fb.hidden = hasApp;
    });
  }

  function refreshReviewsFallback() {
    var spr = document.getElementById('shopify-product-reviews');
    if (!spr) return;
    var panel = spr.closest('.product-tab-panel');
    if (!panel) return;
    var fb = panel.querySelector('[data-pdp-reviews-fallback]');
    if (!fb) return;
    var hasReviews =
      spr.children.length > 0 || (spr.textContent && spr.textContent.trim().length > 0);
    fb.hidden = hasReviews;
  }

  /** AC Questions & Answers: FAQPage JSON-LD içindeki mainEntity sayısı (yayımlanmış Q&A). */
  function countFaqMainEntitiesFromLdJson() {
    var best = 0;
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function (script) {
      var text = (script.textContent || '').trim();
      if (!text) return;
      try {
        var data = JSON.parse(text);
        best = Math.max(best, countFaqInJsonLdNode(data));
      } catch (e) {
        /* ignore */
      }
    });
    return best;
  }

  function countFaqInJsonLdNode(node) {
    if (node == null) return 0;
    if (Array.isArray(node)) {
      var maxArr = 0;
      for (var i = 0; i < node.length; i++) {
        maxArr = Math.max(maxArr, countFaqInJsonLdNode(node[i]));
      }
      return maxArr;
    }
    if (typeof node !== 'object') return 0;
    var local = 0;
    var type = node['@type'];
    var types = Array.isArray(type) ? type : type ? [type] : [];
    if (types.indexOf('FAQPage') !== -1 && Array.isArray(node.mainEntity)) {
      local = node.mainEntity.length;
    }
    var graphMax = 0;
    if (node['@graph'] && Array.isArray(node['@graph'])) {
      graphMax = countFaqInJsonLdNode(node['@graph']);
    }
    return Math.max(local, graphMax);
  }

  function refreshAcqaPricingQuestionsCount() {
    var pending = document.querySelector('[data-acqa-questions-auto]');
    if (!pending || pending.getAttribute('data-acqa-filled') === '1') return;

    var n = countFaqMainEntitiesFromLdJson();
    if (n < 1) return;

    var row = pending.closest('.product-pricing__stats-row');
    var numEl = pending.querySelector('[data-acqa-questions-num]');
    var labEl = pending.querySelector('[data-acqa-questions-label]');
    if (numEl) numEl.textContent = String(n);
    if (labEl && row) {
      var one = row.getAttribute('data-acqa-q-one') || 'Question';
      var other = row.getAttribute('data-acqa-q-other') || 'Questions';
      labEl.textContent = n === 1 ? one : other;
    }
    pending.removeAttribute('hidden');
    pending.setAttribute('data-acqa-filled', '1');
  }

  function bindTablist(root) {
    var tabs = getTabs(root);
    var tablist = root.querySelector('[role="tablist"]');
    if (!tablist || !tabs.length) return;

    tablist.addEventListener('keydown', function (e) {
      var list = Array.prototype.slice.call(tabs);
      var i = list.indexOf(document.activeElement);
      if (i < 0) return;
      var next = i;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        next = (i + 1) % list.length;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        next = (i - 1 + list.length) % list.length;
      } else if (e.key === 'Home') {
        e.preventDefault();
        next = 0;
      } else if (e.key === 'End') {
        e.preventDefault();
        next = list.length - 1;
      } else {
        return;
      }
      var key = list[next].getAttribute('data-tab');
      activate(key);
      list[next].focus();
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-tab'));
      });
    });
  }

  function init() {
    var root = getRoot();
    var panels = getPanels();
    if (!root || !panels.length) return;

    bindTablist(root);
    var initial = tabFromHash() || 'specifications';
    activate(initial);

    window.addEventListener('hashchange', function () {
      var t = tabFromHash();
      if (t) activate(t);
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-pdp-tab-jump]');
    if (!el) return;
    var root = getRoot();
    var panels = getPanels();
    if (!root || !panels.length) return;
    e.preventDefault();
    var key = el.getAttribute('data-pdp-tab-jump');
    if (key) {
      activate(key);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  window.vatpanPdpActivateTab = activate;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var spr = document.getElementById('shopify-product-reviews');
  if (spr && typeof MutationObserver !== 'undefined') {
    var moSpr = new MutationObserver(function () {
      refreshReviewsFallback();
    });
    moSpr.observe(spr, { childList: true, subtree: true, characterData: true });
  }

  document.querySelectorAll('[data-pdp-app-target]').forEach(function (host) {
    if (typeof MutationObserver === 'undefined') return;
    var mo = new MutationObserver(function () {
      refreshAppFallbacks();
    });
    mo.observe(host, { childList: true, subtree: true });
  });

  setTimeout(refreshAppFallbacks, 500);
  setTimeout(refreshReviewsFallback, 500);
  setTimeout(refreshAcqaPricingQuestionsCount, 400);
  setTimeout(refreshAcqaPricingQuestionsCount, 1200);
  setTimeout(refreshAcqaPricingQuestionsCount, 3000);
  setTimeout(refreshAppFallbacks, 2000);
  setTimeout(refreshReviewsFallback, 2000);
})();
